export default __webpack_public_path__ + "3100d4d1dc9f0ca3b6998230b72029f1.svg";